import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class CustomerMappingController {
  constructor($rootScope, $uibModal, $state, $http, toastr) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.customers = [];
    this.qbCustomers = [];
    this.loadCustomers();
    this.loadQbCustomers();
    this.toastr = toastr;

  }

  getCustName(id) {
    let x = _.find(this.qbCustomers, { 'id': id});
    if(x) {
      return x.displayName;
    }
  }


  updateCustomerDetails(id, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/customers/"+id, obj, {withCredentials: true}).then(function (success) {
      self.loadCustomers();
      self.toastr.success("Successfully Paired Customer With Quickbooks!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could Not Pair Customer With Quickbooks.", "ERROR");
    });
  }


  syncCustomersWithQuickbooks() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/customers/sync", {withCredentials: true}).then(function (success) {
      self.loadCustomers();
      self.loadQbCustomers();
    });
  }

  loadCustomers() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
    });
  }

  loadQbCustomers() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/integrations/qb/customers", {withCredentials: true}).then(function (success) {
      self.qbCustomers = success.data;
    });
  }

}

export default CustomerMappingController;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/customer-mapping/customer-mapping.controller.js